module.exports = __webpack_public_path__ + "static/media/edwin.eda63112.jpg";